<!--
参数：
otherColumn:是否显示性别、年龄列
-->
<template>
  <div class="checkbox-detection-list">
    <div>
      <p class="search" style="margin-right:2rem;">搜索检测项：
        <el-input class="searchInput" placeholder="检测项中文" v-model="keys" @mousedown.stop.native @keydown.enter.native="handleIconClick('',false)" @click.stop.native>
          <el-button slot="append" :icon="searchIcon" @click="handleIconClick('',false)"></el-button>
        </el-input>
      </p>
      <div class="content-box">
        <div class="tables">
          <el-tabs v-model="currentTypeFilter" @tab-click="handleClick" slot="title">
            <!-- <el-tab-pane :disabled="isDisabled('COMMON_DISEASES')" label="常见疾病" name='COMMON_DISEASES'></el-tab-pane> -->
            <el-tab-pane label="全部" name=' '></el-tab-pane>
            <el-tab-pane label="常见疾病" name='COMMON_DISEASES'></el-tab-pane>
            <el-tab-pane label="高危遗传病" name='GENETIC_DISEASES'></el-tab-pane>
            <el-tab-pane label="罕见病" name='RARE_DISEASES'></el-tab-pane>
            <el-tab-pane label="药物基因组" name='PHARMACOGENOMICS'></el-tab-pane>
            <el-tab-pane label="生活方式" name='LIFE_STYLE'></el-tab-pane>
            <el-tab-pane label="祖源" name='ANCESTRY'></el-tab-pane>
          </el-tabs>
          <wt-paged-table ref="tables" :on-request-data="getTableData" :total-size="totalSize" :page-size="pageSize" :refresh="true">
            <el-table ref="table1" :data="data" border style="width: 100%;" @select="selectRow" @selection-change="handleSelectionChange" :row-key="getRowKeys" :row-class-name="setClass">
              <el-table-column type="selection" width="55" :reserve-selection="true" :selectable="selectable"></el-table-column>
              <el-table-column prop="id" label="id">
              </el-table-column>
              <el-table-column prop="chineseName" label="中文名称">
              </el-table-column>
              <el-table-column prop="category" label="分类">
                <template slot-scope="scope">
                  {{formatDetectionCategory(scope.row.category)}}
                </template>
              </el-table-column>
            </el-table>
          </wt-paged-table>
        </div>
        <!-- <div class="showSelected" v-if="this.selectedDataCopy.length">
          <h3>已勾选：</h3>
          <div>
            <span v-for="(item,index) in this.selectedDataCopy" :key="index">{{item.chineseName}}</span>
          </div>
        </div> -->
      </div>

    </div>
  </div>
</template>
<script>
import { formatDetectionCategory, formatConfigType, formatConfigSex } from 'enumeration/lab-order.js'
export default {
  name: 'checkbox-lot-detail-list',
  props: ['otherColumn', 'selected', 'category', 'seeDetection', 'basePackageId'],
  data () {
    return {
      pageSize: 10,
      totalSize: 10,
      data: [],
      selectedDataCopy: [], // this.formatInData(this.selected),
      // 搜索
      searchIcon: 'el-icon-search',
      keys: '',
      currentTypeFilter: this.category || ' ',
      currentParams: {},
      copySelected: JSON.parse(JSON.stringify(this.selected)),
      newSelected: [],
      resetPage: false
    }
  },
  watch: {
    'selectedDataCopy': {
      handler: function (newVal) {
        if (newVal) {
          // this.getNewSelected(newVal)
          console.log('---emit', newVal)
          this.$emit('getSelected', newVal)
        }
      },
      deep: true
    },
    'selected': {
      handler: function (newVal) {
        // console.log('newVal--------', newVal)
        this.formatInData(newVal)
      },
      deep: true
    },
    category (val) {
      if (val) {
        this.handleFilter(val)
      } else {
        this.currentTypeFilter = ' '
      }
    },
    seeDetection (val) {
      if (val.name) {
        this.handleIconClick(val.name)
      } else {
        this.keys = ''
        this.currentParams = {}
        this.$refs.tables.load()
      }
    }
  },
  methods: {
    formatDetectionCategory,
    formatConfigType,
    formatConfigSex,
    getNewSelected (allSelected) {
      this.newSelected = []
      let oldSelected = this.copySelected.map(e => e.id || e.detectionItemId)
      allSelected.forEach(e => {
        if (!oldSelected.includes(e.id)) {
          this.newSelected.push(e)
        }
      })
    },
    getRowKeys (row) {
      return row.id
    },
    isDisabled (type) {
      if (!this.category) return false

      if (!type) return true
      if (type === this.category) return false
      return true
      // return false
    },
    selectable (row, index) {
      // let getInIds = this.copySelected.map(e => e.id || e.detectionItemId)
      // if (getInIds.includes(row.id)) {
      //   row.canNotExpend = true
      //   return false
      // }
      // return true
      return true
    },
    setClass ({ row, rowIndex }) {
      if (row.canNotExpend) {
        return 'not-expend'
      }
      return ''
    },
    async recurTest (index, length, data) {
      console.log('ata', data)
      if (length) {
        data[index].id = data[index].detectionItemId || data[index].id
        data[index].chineseName = data[index].name || data[index].chineseName
        // 新接口
        try {
          let detectionRes = await this.$store.dispatch('getDetectionWithCorpusAndConfig', data[index].id)
          data[index].category = detectionRes.data.category
          this.contrlDetectionCheckbox(data[index])
        } catch (err) {
          console.log(err)
          this.$message.warning(err)
        }
      }

      console.log('第' + (index) + '次循环')
      if (++index < length) {
        this.recurTest(index, length, data)
      } else {
        console.log('-------------------------------------------------------over')
      }
    },
    formatInData (arr) {
      // this.reload()
      if (!arr.length) {
        // this.reset()
        console.log('this.selectedDataCopy-----------aa--', this.selectedDataCopy)
        this.selectedDataCopy.forEach(ele => {
          this.deleteTargetRow(ele)
        })

        // this.selectedDataCopy = []
      } else {
        arr.forEach(e => {
          e.id = e.detectionItemId || e.id
          e.chineseName = e.name || e.chineseName
          e.getIn = true
        })
        this.selectedDataCopy = JSON.parse(JSON.stringify(arr))
      }
    },
    reset () {
      this.keys = ''
      this.reload()
      this.$refs.table1.clearSelection()
    },
    // 分页之后对已选中的数据进行处理
    handleData (pageData) {
      let selectedIds = this.selectedDataCopy.map(e => e.id)
      let getInDataIds = this.selectedDataCopy.filter(e => e.getIn === true).map(e => e.id)
      let needRecurTest = []
      console.log('getInDataIds', getInDataIds)
      pageData.forEach((ele, index) => {
        // 对当前已经勾选的数据进行勾选渲染
        if (selectedIds.includes(ele.id)) {
          let targetData = this.selectedDataCopy.filter(e => e.id === ele.id)[0]
          this.$set(pageData, index, targetData)
        } else {
        //   console.log('-----------handleData--------deleteTargetRow-------')
          this.deleteTargetRow(ele)
        }

        if (getInDataIds.includes(ele.id)) {
          needRecurTest.push(this.selectedDataCopy.filter(e => e.id === ele.id)[0])
        }
      })
      // console.log('needRecurTest-----', needRecurTest)
      // 对传进的数据进行相应的勾选
      if (needRecurTest.length) {
        // 对传入的非现在勾选的数据进行勾选
        this.recurTest(0, needRecurTest.length, needRecurTest)
      }
    },
    // 只对新勾选的数据进行添加操作，取消勾选的删除操作放在每行操作的数据里
    handleSelectionChange (val) {
      console.log('val------------', val)
      let newSelected = val.filter(e => !e.getIn).map(e => e.id)
      val.forEach(ele => {
        if (newSelected.includes(ele.id)) {
          this.selectedDataCopy.unshift(ele)
        } else {
          this.selectedDataCopy.push(ele)
        }
        // 数组去重
        this.selectedDataCopy = this.arrayUnique(this.selectedDataCopy, 'id')
        // }
      })
      // console.log('this.selectedDataCopy=======', this.selectedDataCopy)
    },
    deleteTargetRow (row) {
    //   console.log('-----deleteTargetRow------------row-------r-r-r-')
      this.$refs.table1.toggleRowSelection(row, false)
      // 从勾选列表中删除
      this.selectedDataCopy.forEach((e, index) => {
        if (e.id === row.id) {
          this.selectedDataCopy.splice(index, 1)
        }
      })
    },
    // 根据某个属性进行去重
    arrayUnique (arr, name) {
      var hash = {}
      return arr.reduce((item, next) => {
        if (!hash[next[name]]) {
          hash[next[name]] = true && item.push(next)
        }
        // hash[next[name]] ? '' : hash[next[name]] = true && item.push(next)
        return item
      }, [])
    },
    selectRow (rows, row) {
      let flag = 0
      console.log('rows', rows)
      if (rows.map(e => e.id).includes(row.id)) {
        flag = 1
      }
      if (flag) {
        // 选中的话

      } else {
        // 不选中，表单重置
        // 从勾选列表中删除
        console.log('------------eee--ss-el')
        this.deleteTargetRow(row)
      }
    },
    // 控制检测项的多选
    contrlDetectionCheckbox (data) {
      this.$refs.table1.toggleRowSelection(data, true)
    },
    buildFilterParams (page, params = {}) {
      if (Object.keys(params).length) {
        params['page'] = page
        params['size'] = this.pageSize
        params.getAllConfigs = true
        params.getCorpus = true
        if (this.seeDetection.name) {
          params.chineseName = this.seeDetection.name
          this.keys = this.seeDetection.name
        } else if (this.keys) {
          params.chineseName = this.keys
        } else {
          params.chineseName = null
        }
        if (this.currentTypeFilter && this.currentTypeFilter !== 'NOTSET') {
          params.category = this.currentTypeFilter
        } else {
          params.category = null
        }
        params.detectionPackageId = this.basePackageId
        return params
      } else {
        let data = {
          page: page,
          size: this.pageSize,
          category: this.currentTypeFilter,
          getAllConfigs: true,
          getCorpus: true,
          detectionPackageId: this.basePackageId
        }
        if (this.seeDetection.name) {
          data.chineseName = this.seeDetection.name
          this.keys = this.seeDetection.name
        } else if (this.keys) {
          data.chineseName = this.keys
        } else {
          params.chineseName = null
        }
        return data
      }
    },
    getTableData (page, next) {
      if (!this.basePackageId) {
        return
      }
      let data = this.buildFilterParams(page, this.currentParams)
      this.$store.dispatch('getItemsByBaseId', data).then(res => {
        if (next) {
          next(res.data)
        }
        this.data = res.data
        this.totalSize = res.totalNumber
        this.handleData(this.data)
      }).catch(err => {
        this.$refs.tables.showReTry()
        this.$message.error(err)
      })
    },
    // 刷新列表
    reload () {
      this.$nextTick(() => {
        this.currentParams = {}
        this.$refs.tables.load()
      })
      this.selectedData = []
    },

    // 搜索
    async handleIconClick (text) {
      this.currentTypeFilter = ' '
      this.$refs.tables.resetPage()
    },
    handleClick (tab) {
      this.getTableData(0)
      // this.$refs.tables.resetPage()
    },
    // 清空所选的数据
    clearSelected () {
      this.selectedDataCopy = []
    },
    handleFilter (category) {
      this.currentTypeFilter = category
      let tab = {
        name: category
      }
      this.handleClick(tab)
    }
  },
  mounted () {
    if (!this.selected.length) {
      this.reset()
    } else {
      this.formatInData(this.selected)
    }
    if (this.category && this.category !== 'NOTSET') {
      this.handleFilter(this.category)
    } else {
      this.currentTypeFilter = ' '
    }
  }
}
</script>
<style lang="less">
.checkbox-detection-list{
  .content-box{
    display: flex;
  }
  .el-tabs__nav-scroll{
    text-align: center;
  }
  .el-tabs__nav{
    display: inline-block;
    float: none;
  }
  .tables{
    width:50%;
    margin-top:10px;
    .el-table__empty-block{
      min-height:49px;
    }
    .el-pagination{
      // width:100%;
      padding-top:20px;
    }
    .el-table .cell{
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
    }
  }
  .el-input{
    width:500px;
  }
  .config{
    padding-left: 55px;
    margin: 10px 0;
  }
  .marginL{
    margin-left: 80px;
  }
  .p-margin{
    margin-left: 25px;
  }
  .showSelected{
    padding-left: 30px;
    width:47%;
    span{
      width:250px;
      display: inline-block;
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
    }
  }
  th .el-checkbox{
    display: none;
  }
  .ver{
    .el-radio{
      display:block;
      line-height: 30px;
    }
    .el-radio + .el-radio {
      margin-left:0;
    }
  }
  .not-expend .el-table__expand-column .cell {
    display: none;
  }
  // ----------------------
  .tables{
    width: 90%;
    margin:0 auto;
    .el-input{
      max-width: 50px;
    }
  }

  .el-table{
    width: 100%
  }
  .el-tabs__nav-wrap{
    display: inline-block;
  }
  .el-tabs__header{
    text-align: center;
  }

}

</style>
